import { Locale } from '@cars4ever/public-ui';

import { TTextsOverride } from '@digital-dealer/texts-service';

import danish from './danish';
import swedish from './swedish';

const overrideTexts: Record<Locale, TTextsOverride> = {
  [Locale.DK]: danish,
  [Locale.SE]: swedish,
};

export default overrideTexts;
